import Cookies from 'js-cookie';
import { OAUTH_TOKEN_NAME } from '@constants/appConstants';

interface StoredOAuthToken {
  authenticated?: {
    access_token?: string;
    token_type?: string;
    expires_in?: number;
    created_at?: number;
    refresh_token?: string;
    scope?: string;
    locker_manager_id?: number;
    authenticator?: string;
  };
}

export const getStoredOAuthToken = (): StoredOAuthToken | undefined => {
  const cookieValue = Cookies.get(OAUTH_TOKEN_NAME);
  if (!cookieValue) return undefined;

  try {
    return JSON.parse(cookieValue);
  } catch {
    // Malformed cookie — treat the user as logged out
    return undefined;
  }
};

export const isOAuthTokenValid = (): boolean => {
  const tokenData = getStoredOAuthToken();
  if (!tokenData?.authenticated) return false;

  const { created_at, expires_in } = tokenData.authenticated;
  if (!created_at || !expires_in) return true;

  const expiresAt = (created_at + expires_in) * 1000;
  return Date.now() < expiresAt;
};

/**
 * Client-side fallback removal of the shared cookie. The server is the owner
 * and clears it via DELETE /session; this covers the case where that call fails.
 * Also removes the legacy localStorage copy left behind for pre-migration users.
 */
export const clearOAuthToken = (): void => {
  Cookies.remove(OAUTH_TOKEN_NAME, { path: '/' });
  if (window.location.hostname.endsWith('squadlocker.com')) {
    Cookies.remove(OAUTH_TOKEN_NAME, { path: '/', domain: 'squadlocker.com' });
  }
  localStorage.removeItem(OAUTH_TOKEN_NAME);
};
